"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmOrderOrderInnerStatusToJSON = exports.ConfirmOrderOrderInnerStatusFromJSONTyped = exports.ConfirmOrderOrderInnerStatusFromJSON = exports.instanceOfConfirmOrderOrderInnerStatus = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ConfirmOrderOrderInnerStatus interface.
 */
function instanceOfConfirmOrderOrderInnerStatus(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfConfirmOrderOrderInnerStatus = instanceOfConfirmOrderOrderInnerStatus;
function ConfirmOrderOrderInnerStatusFromJSON(json) {
    return ConfirmOrderOrderInnerStatusFromJSONTyped(json, false);
}
exports.ConfirmOrderOrderInnerStatusFromJSON = ConfirmOrderOrderInnerStatusFromJSON;
function ConfirmOrderOrderInnerStatusFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'statusDate': !(0, runtime_1.exists)(json, 'status_date') ? undefined : json['status_date'],
        'statusName': !(0, runtime_1.exists)(json, 'status_name') ? undefined : json['status_name'],
        'statusMessage': !(0, runtime_1.exists)(json, 'status_message') ? undefined : json['status_message'],
    };
}
exports.ConfirmOrderOrderInnerStatusFromJSONTyped = ConfirmOrderOrderInnerStatusFromJSONTyped;
function ConfirmOrderOrderInnerStatusToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status_date': value.statusDate,
        'status_name': value.statusName,
        'status_message': value.statusMessage,
    };
}
exports.ConfirmOrderOrderInnerStatusToJSON = ConfirmOrderOrderInnerStatusToJSON;
